import React from 'react'
import { inject, observer } from 'src/core/store'
import './index.less'
import http from 'src/helper/http'
import './index.less'
import { getlang, setlang } from 'src/helper/getlang'
import Message from '../../../component/Message'
import langM from './lang'
import { history } from 'src/core/router'
import { setDocumentTitle, setUidToken } from 'src/helper/tool'
import lang from './lang'
import localstorage from 'src/helper/localstorage'
import config from 'src/core/config'
import hybridRouter from 'src/core/hybrid-router'

@inject('store')
@observer
export default class extends React.Component {
  state = {
    lang: langM.en,
    userName: '',
    password: '',
    language: 'en'
  }

  async componentWillMount() {
    // 跳转到新界面
    window.location.href = config.hostHybrid + hybridRouter.agentLogin

    //设置语言 start
    let { language } = this.props.location.query
    language = await getlang(language)
    this.setState({
      lang: setlang(language, langM),
      language: language,
    })
    console.log('language', language)

    // end
    let uid = await setUidToken(this.props.location.query)
    console.log(uid, 'uni')    
  }
  loginTo = async () => {
    let { password, userName } = this.state
    console.log(password, userName)
    let res = await http.post('/withoutsign/user/loginweb', { "account": userName, password })
    if (res.code != 0) {
      this.refs.msg.show(lang.errorTexl || res.msg)
    } else if (res.code == 0) {
      console.log(res)
      if (parseInt(res.res.uid) > 0 && res.res.accesstoken && res.res.accesstoken != '') {
        await localstorage.set('userInfo', { uid: parseInt(res.res.uid), accesstoken: res.res.accesstoken })
      }
      history.push(`/app/ruby-agent`)
    }

  }
  getUserSet = (e, key) => {
    console.log(e.target.value, key)
    this.setState({
      [key]: e.target.value
    })
  }
  render() {
    let { lang } = this.state
    return <div className="appLgruby">
      <div className='title-view'></div>
      <div className='getUserInfo'>
        <input className='inputsty' placeholder={lang.userPlod} onChange={e => this.getUserSet(e, 'userName')}></input>
        <input className='inputsty' placeholder={lang.passwordPlod} onChange={e => this.getUserSet(e, 'password')} type='password'></input>
      </div>
      <div className='handle' onClick={this.loginTo}>{lang.LoginIn}</div>
      <Message ref="msg" />
    </div>
  }
}



// WEBPACK FOOTER //
// src/pages/app/agentlogin/index.js